module.exports = __webpack_public_path__ + "media/images/home/produto_chuva_sample2-a2ffc9785afd108474ffda0a258033a5.png";